export const Auth_API = {
  AuthEncrypt: '/accident-platform/auth/encrypt',
  AuthLogin: '/accident-platform/auth/login',
  AuthLogout: '/accident-platform/auth/logout',
  RoleQueryAll: '/accident-platform/role/query/all',
  UserRefreshToken: '/accident-platform/user/refresh/token',
  UserModifyPassword: '/accident-platform/user/modify/password',
} as const;
